import { ReactNode } from "react";
import { Avatar, Box, Card, Typography } from "@mui/material";
import { brandGradients } from "../../themes/brandTokens";

// A dashboard tile: an icon badge and a label on top, the figure or action in the middle,
// a one-line footer (a link or a hint) at the bottom. Tiles in a row share the same height.
const StatCard = ({
  icon,
  label,
  children,
  footer,
}: {
  icon: ReactNode;
  label: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) => (
  <Card sx={{ height: "100%", display: "flex", flexDirection: "column", p: 2.5 }}>
    <Box display="flex" alignItems="center" gap={1.25}>
      <Avatar sx={{ width: 36, height: 36, background: brandGradients.button, color: "common.white", "& .MuiSvgIcon-root": { fontSize: 20 } }}>
        {icon}
      </Avatar>
      <Typography variant="body2" color="text.secondary" fontWeight={500}>
        {label}
      </Typography>
    </Box>
    <Box flex={1} display="flex" alignItems="center" py={2.5}>
      {children}
    </Box>
    {footer && (
      <Box sx={{ pt: 1.5, borderTop: 1, borderColor: "divider", fontSize: 14 }}>
        {footer}
      </Box>
    )}
  </Card>
);

export default StatCard;
